import { styled } from '@mui/material'

import { BaseContainer } from '../../config/styles/BaseGrid'

export const Root = styled(BaseContainer)`
  align-items: center;
  display: flex;
  justify-content: center;
`
